// ─── Définitions des indicateurs, par rapport (2026-10-22) ───────────────────
// UNE fiche par rapport, tenue avec le code du rapport (ce sont des
// définitions : elles changent avec le calcul, pas au fil des jours).
// Deux usages :
//   · au survol d'un en-tête de colonne : la formule courte (`formule`) ;
//   · au clic droit sur un bloc marqué `data-definitions="<clé>"`, la fenêtre
//     « D'où viennent ces chiffres ? » : formule, explication, sources, règles,
//     et le calcul refait avec les chiffres de la ligne cliquée (`calcul`).
// `calcul` : { num: [libellés de colonnes additionnés], den: [idem] } — les
// libellés sont ceux des en-têtes du tableau.

export const DEFINITIONS = {
  'apv-productivite': {
    titre: 'APV — Productivité',
    sources: [
      'Présence : heures badgées dans Kelio, par compagnon et par jour.',
      'Heures pointées, affectées et facturées : DataCar, par compagnon, jour et OR.',
      'Fichier « pointages sur OR » chargé chaque nuit dans A97 Data, depuis le 2 janvier 2026.',
    ],
    colonnes: [
      { libelle: 'Présence', formule: 'Heures badgées dans Kelio' },
      { libelle: 'Pointé OR', formule: 'Heures pointées sur les OR, hors OR interne 999999' },
      { libelle: 'Interne', formule: 'Heures pointées sur l\'OR interne 999999 (attente, entretien, formation)' },
      { libelle: 'Facturé', formule: 'Heures facturées aux clients, au jour de la facture' },
      {
        libelle: 'Occupation', formule: '(Pointé OR + Interne) ÷ Présence',
        calcul: { num: ['Pointé OR', 'Interne'], den: ['Présence'] },
        detail: 'Part du temps de présence pendant laquelle le compagnon est pointé, temps interne compris. '
          + 'Au-dessus de 100 %, il y a plus d\'heures pointées que d\'heures badgées : pointages qui se chevauchent, '
          + 'oubli de badgeage, ou compagnons sans badge Kelio dont le pointé compte sans présence en face.',
      },
      {
        libelle: 'Productivité', formule: 'Pointé OR ÷ Présence',
        calcul: { num: ['Pointé OR'], den: ['Présence'] },
        detail: 'Part du temps de présence passée sur des OR clients. Le temps interne (attente, entretien, formation) n\'en fait pas partie.',
      },
      {
        libelle: 'Efficience', formule: 'Facturé ÷ Pointé OR',
        calcul: { num: ['Facturé'], den: ['Pointé OR'] },
        detail: 'Vend-on le temps passé ? Au-dessus de 100 %, on facture plus d\'heures que le temps réellement passé '
          + '(temps barèmés, forfaits). En dessous, une partie du travail n\'est pas facturée.',
      },
      {
        libelle: 'Rendement', formule: 'Facturé ÷ Présence',
        calcul: { num: ['Facturé'], den: ['Présence'] },
        detail: 'Heures vendues pour une heure de présence : c\'est l\'indicateur de synthèse, il combine la productivité et l\'efficience.',
      },
    ],
    regles: [
      'Le pointé est daté du jour du travail, le facturé du jour de la facture : les ratios se lisent sur un mois ou un cumul, jamais sur une seule journée.',
      'Dans un regroupement de sociétés, la présence d\'un compagnon est comptée une seule fois par jour : un compagnon partagé entre Autodis et Centre Auto a sa présence entière dans chacune.',
      'Compagnons « non rapprochés » : sans badge Kelio, leur pointé compte mais sans présence en face. Ils font monter la productivité et l\'occupation de leur société.',
      'L\'atelier d\'une heure est celui du compagnon, pas celui de l\'OR : un mécanicien qui pointe sur un OR du rapide reste compté à la mécanique.',
    ],
  },
};

export const formuleDe = (cle, libelle) => {
  const d = DEFINITIONS[cle];
  const c = d && d.colonnes.find((x) => x.libelle === libelle);
  return c ? c.formule : undefined;
};
